"use strict";

const PostConstructionProjectPopupGeoServerLayer = function () {
  var loadDomListeners = function ($popup) {
    $popup.off("click", ".lid-popup-show-history");
    $popup.on("click", ".lid-popup-show-history", _showInspectionHistory);

    $popup.off("click", ".lid-popup-back-button");
    $popup.on("click", ".lid-popup-back-button", clickOnBackButton);

    $popup.off("click", ".lid-popup-delete-button");
    $popup.on("click", ".lid-popup-delete-button", deleteLidProject);

    $popup.off("click", ".view-lid-project-inventory");
    $popup.on("click", ".view-lid-project-inventory", viewLidProjectInventory);

    $popup.off("click", ".js-view-summary");
    $popup.on("click", ".js-view-summary", LidProjectPopup.handleViewSummaryClick);

    $popup.off("click", "#construction-complete-project-btn");
    $popup.on("click", "#construction-complete-project-btn", openCompleteModal);

    $popup.off("click", ".lid-popup-update-response");
    $popup.on("click", ".lid-popup-update-response", LidProjectPopup.handleUpdateResponseClick);

    $popup.off("click", ".js-lid-generate");
    $popup.on("click", ".js-lid-generate", LidProjectPopup.handleGenerateLetterClick);

    $popup.off("click", ".lid-popup-fact-sheet");
    $popup.on("click", ".lid-popup-fact-sheet", clickOpenFactSheet);

    $popup.off("click", ".download-inspection-report");
    $popup.on("click", ".download-inspection-report", LidProjectPopup.handleDownloadLetterClick);

    $popup.off("click", ".download-summary-report");
    $popup.on("click", ".download-summary-report", LidProjectPopup.handleDownloadSummaryClick);

    $popup.off("click", ".download-response-report");
    $popup.on("click", ".download-response-report", LidProjectPopup.handleDownloadResponseClick);

    $popup.off("click", ".js-delete-summary");
    $popup.on("click", ".js-delete-summary", LidProjectPopup.handleDeleteSummaryClick);
  };

  var viewLidProjectInventory = function () {
    const id = $(this).parents(".popup-lid-project").data("id");
    ProjectInventoryModalController.invokeProjectInventoryModal(id);
  };

  var openCompleteModal = function (e) {
    const $row = $(e.currentTarget).closest("div");
    const id = $row.data("id");

    ProjectCompleteModal.renderAndShow(id);
  };

  var getPopupHtml = function (properties) {
    return PopupContent.getLayerPopup(properties, "postConstructionProjectG2");
  };

  var onPopupOpen = async function (properties) {
    const id = properties.id;
    var data = await getPopupData(id);
    const html = getPopupHtml(data);
    const $popup = $(".leaflet-popup-content");
    $popup.html(html);
    loadDomListeners($popup);
    LidProjectPopup.renderSiteVisitHistoryBarGraph(
      data.lidHistory.filter((history) => !!history.result),
    );
    LidSelfInspectionHistory.load(data);
  };

  var deleteLidProject = function () {
    const data = $(this).closest(".popup-general").data();
    MessageModal.showThreeButtonConfirmWarningModal(
      `Delete Construction Project ${data.name} ? Click "Delete Project" to permanently delete the project and all associated inspections, photos and files. Click "Delete Project & Assets" to delete the project and all associated stormwater assets. Click "Cancel" to return.`,
      async function () {
        await ApiCalls.deleteProjectFactSheet(data.id);
        _closePopupAndReloadLayer();
      },
      async function () {
        await ApiCalls.deleteProjectFactSheet(data.id, true);
        _closePopupAndReloadLayer();
      },
      "Cancel",
      "Delete Project",
      "Delete Project & Assets",
    );
    Analytics.sendPopupEvent("delete_asset", "lid-project");
  };

  var _closePopupAndReloadLayer = function () {
    const popupCloseButn = $(".leaflet-popup-close-button");
    if (popupCloseButn.length) {
      popupCloseButn[0].click();
    }
    PostConstructionProjectGeoServerLayer.loadLayer();
  };

  var getPopupData = async function (id) {
    const isTodo = Tree.get("activeTab") === "todo";
    const data = await ApiCalls.getLidProjectById(id);
    data.popupColor = LidProjectStyles.getNewLidColor(data, isTodo);
    data.tierNumber = LidIcon.getLidProjectTierNumber(data);
    data.allPerformanceTierString = LidProjectPopup.getAllPerformanceTierString(data);
    data.permissions = UserPermissions.getAllPermissions();

    return data;
  };

  var _showInspectionHistory = function (projectId) {
    $(".popup-main-pane").hide();
    $(".lid-popup-back-button").show();
    $(".popup-history-pane").show();
    $(".lid-popup-delete-button").show();
    Analytics.sendPopupEvent("view_historyTab", "lid-project");
  };

  var clickOnBackButton = function () {
    $(".popup-main-pane").show();
    $(".popup-history-pane").hide();
    $(".lid-popup-back-button").hide();
    $(".lid-popup-delete-button").hide();
  };

  var clickOpenFactSheet = function () {
    const id = $(this).parents(".popup-lid-project").data("id");
    UrlRoutes.go("lid-fact-sheet", { id });
    Analytics.sendPopupEvent("view_details", "lid");
  };

  return {
    loadDomListeners,
    getPopupHtml,
    onPopupOpen,
    getPopupData,
    _showInspectionHistory,
  };
};

module.exports = PostConstructionProjectPopupGeoServerLayer();

const ApiCalls = require("../apiCalls");
const PopupContent = require("../mapFunctions/popupContent");
const MessageModal = require("../modals/messageModal");
const Analytics = require("../general/analytics");
const ProjectInventoryModalController = require("../construction/projectInventoryModalController");
const ProjectCompleteModal = require("../construction/projectCompleteModal");
const PostConstructionProjectGeoServerLayer = require("./postConstructionProjectGeoServerLayer");
const LidProjectStyles = require("../lid/lidProjectStyles");
const LidIcon = require("../lid/lidIcon");
const LidProjectPopup = require("../lid/lidProjectPopup");
const UserPermissions = require("../login/userPermissions");
const LidSelfInspectionHistory = require("../lid/lidSelfInspectionHistory");
const Tree = require("../tree");
const UrlRoutes = require("../routes/urlRoutes");
